import { h } from 'preact';
import { forwardRef } from 'preact/compat';
import styled, {css} from 'styled-components';
import { MQUERY } from 'common/constants';

const Button = forwardRef(function Button(props, ref) {
    const { children, className, href, target, onClick, onMouseEnter } = props;
    
    return (
        <Primary 
            css={ButtonCss} 
            className={className}
            ref={ref} 
            as={href ? "a" : "button"} 
            href={href} 
            onClick={onClick} 
            onMouseEnter={onMouseEnter} 
            target={target}
        >
            {children}
        </Primary>
    );
});

export default Button;

export function SecondaryButton(props) {
    const { children, className, href, target, onClick, onMouseEnter } = props;
    return (
        <Secondary css={ButtonCss} className={className} as={href ? "a" : "button"} href={href} onClick={onClick} onMouseEnter={onMouseEnter} target={target}>
            {children}
        </Secondary>
    );
}

export const ButtonCss = css`
    display: flex;
    padding: 1.1rem;
    align-items: center;
    display: flex;
    justify-content: center;
    line-height: 1;
    font-size: var(--default);
    font-weight: var(--bold);
    color: var(--primaryDark);
    cursor: pointer;
    background-color: var(--button);
    border-radius: .8rem;
    /* so we can animate on hover */
    border: .1rem solid transparent;
    transition: background-color .3s, border-color .3s;

    &.no-style {
        color: inherit;
        border: 0;
        background-color: inherit;
        transition: color .3s;

        &:hover {
            color: var(--button);
        }
    }

    &.ghost {
        background-color: inherit;
        border: .1rem solid var(--button);
        transition: background-color .3s;
        color: var(--button);

        &:hover {
            background-color: var(--button);
            color: var(--primaryDark);
        }
    }

    &.read-more-default {
        flex: none;
        padding-left: 0;
        padding-top: 0;
        margin-top: -0.3rem;

        svg {
            width: 1.6rem;
            margin-left: 0.6rem;
            rotate: ${({expanded}) => ( expanded ?  '180deg' : '0' )};
        }
    }

    &.read-more-styled {
        flex: 1;
        padding: 1.1rem;
        text-indent: 2.2rem; // calculation of the svg width + margin

        svg {
            width: 1.6rem;
            margin-right: 0;
            margin-left: .6rem;
            rotate: ${({expanded}) => ( expanded ?  '180deg' : '0' )};
        }
    }

    &.marker {
        background-color: var(--yellow);
        border: none;
        border-radius: 3rem;
        box-shadow: 0 2px 6px 0 rgba(#000, .35);
        color: var(--neutral800);
        font-size: var(--meta);
        padding: .5rem 1.2rem;

        svg {
            height: 1.6rem;
            margin-right: .4rem;
            width: 1.6rem;
        }

        &:hover {
            background-color: var(--yellowDark);
            color: var(--neutral800);
        }
    }

    svg {
        fill: currentColor;
        flex-shrink: 0;
    }

    @media ${MQUERY.DESKTOP_SMALL} {
        
        &:hover {
            text-decoration: none;
            border-color: var(--button);
            background-color: var(--primaryDark);
            color: var(--button);
    
            svg {
                fill: currentColor;
            }
        }
    }
`;

const Primary = styled.a``;

const Secondary = styled(Primary)`
    color: var(--text);
    background-color: var(--neutral600);
`;
